<template>
  <div v-if="goodsInfo && goodsInfo.goodId" style="width: 100%" class="skuComponents">
    <div class="skusList">
      <Fence
        v-for="item in goodsInfo.skuProps"
        :key="item.propId"
        :all-sku="allSku"
        :fence="item"
        :seletedSku="seletedSku"
        @changeSelectedSku="changeSelectedSku"
      />
    </div>
    <div v-show="goodsInfo.relateGoods">
      <div>
        <div v-for="relateGood in goodsInfo.relateGoods" class="cell">
          <Sf-image
            class="cell-image"
            :class="[
              { 'cell-active': isActive(relateGood) },
              { 'cell-disabled': isDisable },
            ]"
            :src="relateGood.image"
            :alt="relateGood.title"
            :title="relateGood.title"
            @click="goItem(relateGood)"
            :height="80"
            :width="80"
          ></Sf-image>
        </div>
      </div>
    </div>
    <div class="goodPostage" v-if="!hidePost">
      <getPostage :sku="SkuVal" />
    </div>
    <div
      v-if="goodsInfo && goodInfo.shippingPeriod > 0"
      class="goodPostage"
      style="line-height: 1"
    >
      {{ $t('good.shoppingDateLabel') }} {{ goodsInfo.shippingPeriod }}
      {{ $t('good.shippingPeriod') }}
    </div>
    <!-- <wholesale :id="goodsInfo.goodId" style="margin-bottom: var(--spacer-base)" :minRow="3" /> -->
    <div class="sku-actions">
      <SfAddToCart
        v-if="showBtn"
        v-model="selectedCount"
        @input="changeNumber"
        :disabled="loading"
        class="product__add-to-cart-box"
        @click="addToCart"
      >
        <template #add-to-cart-btn>
          <div class="add_class_group">
            <sf-button
              v-if="showBtn"
              :disabled="loading"
              class="product__add-to-cart"
              @click="addToCart"
              >{{ $t('add_To_Cart') }}</sf-button
            >
            <sf-button
              :disabled="loading"
              :class="{
                'product__add-to-wishlist': true,
                'sf-button--text': true,
              }"
              @click="addToWishlist"
              >{{ $t('add_To_Wishlist') }}</sf-button
            >
          </div>
        </template>
      </SfAddToCart>
      <SfButton v-if="showMs" @click="addMsItemSku">
        {{ $t('添加满送商品') }}
      </SfButton>
    </div>
  </div>
</template>
<script>
import Fence from './Fence.vue';
import { SfButton, SfAddToCart, SfImage } from '@storefront-ui/vue';
import { getAllSku, seletedSku2props_ids } from './skuHelper.js';
import { ref, onMounted, computed, useRouter } from '@nuxtjs/composition-api';
import { useOCart, useWishlist } from '@bee-hole/coms';
import { useUiNotification } from '~/composables';
import { EventBus } from '@/plugins/eventBus';
import wholesale from '~/components/Products/wholesale.vue';
import getPostage from '~/components/Products/getPostage.vue';
import { useUiState } from "~/composables";
export default {
  components: {
    SfButton,
    SfAddToCart,
    Fence,
    SfImage,
    wholesale,
    getPostage
  },
  props: {
    goodInfo: {
      type: Object,
      reqired: true
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    showMs: {
      type: Boolean,
      defualt: false
    },
    hidePost: {
      type: Boolean,
      default: false
    }
  },
  setup({ goodInfo: dataInfo }, { emit, root }) {
    // const { result: pifaResult } = useWholesale();
    const {
      toggleCartSidebar,
      isMobile
    } = useUiState();
    const router = useRouter();
    const goodsInfo = ref(dataInfo);
    const seletedSku = ref({});
    const allSku = ref([]);
    const skuText = ref('');
    const selectedCount = ref(1);
    const { addItem, loading: cartLoading } = useOCart();
    const notify = useUiNotification();
    const SkuVal = ref();
    const { addItem: addItemToWishlist, isInWishlist, removeItem: removeItemFromWishlist, wishlist } = useWishlist();
    const isActive = ((itemInfo) => {
      const isActive = (dataInfo.goodId === itemInfo.good_id);
      return isActive;
    });
    const isDisable = ref(false);
    const goItem = (itemInfo) => {
      if (itemInfo.good_id !== dataInfo.goodId) {
        const title = itemInfo.title?.replace(/\//g, '-');
        router.push(root.localePath(`/p/${itemInfo.good_id}/${title}`));
      }
    };
    const initAllSku = () => {
      // 先过滤掉 库存为0的sku
      const newSkus = dataInfo.skus.filter((item) => {
        return item.stockNum > 0;
      });
      // 在获取所有潜在sku
      allSku.value = getAllSku(newSkus);
    };
    const getSkuText = (type = 1) => {
      const optText = [];
      const chooseText = [];
      const chooseTextJson = {};
      for (const key in seletedSku.value) {
        const val = seletedSku.value[key];
        if (val) {
          chooseText.push(val.propValue);
          const propName = dataInfo.skuProps.find((item) => {
            return String(item.propId) === String(key);
          }).propName;
          chooseTextJson[propName] = val.propValue;
        } else {
          optText.push(
            dataInfo.skuProps.find((item) => {
              return String(item.propId) === String(key);
            }).propName
          );
        }
      }
      if (type === 1) {
        skuText.value =
          optText.length > 0
            ? '选择：' + optText.toString()
            : '已选：' + chooseText.toString();
        return optText.length > 0
          ? optText.toString()
          : chooseText.toString();
      } else {
        skuText.value =
          optText.length > 0
            ? '选择：' + optText.toString()
            : JSON.stringify(chooseTextJson);
        return optText.length > 0
          ? optText.toString()
          : JSON.stringify(chooseTextJson);
      }

    };
    const getSkuBySelectedSku = () => {
      const sku = dataInfo.skus.find((item) => {
        return item.propsIds === seletedSku2props_ids(seletedSku.value);
      });
      if (sku) {
        sku.num = selectedCount.value;
      }
      if (sku && !sku.skuImage) {
        sku.skuImage = dataInfo.imageUrl || dataInfo.imageUrl1;
      }
      return sku;
    };
    const changeSelectedSku = (pid, cell) => {
      // 直接替换数组元素，dom不会更新，建议使用set方法
      seletedSku.value[pid] = cell;
      // 针对对象值的改变，需要用原对象与要混合进去的对象的属性一起创建一个新的对象。
      seletedSku.value = Object.assign({}, seletedSku.value);
      const sku = getSkuBySelectedSku();
      // console.log('changeSelectedSku', seletedSku.value, sku);
      if (sku) {
        sku.exchangeRate = goodsInfo.value.exchangeRate;
        SkuVal.value = sku;
        emit('changeSelectedSku', { result: seletedSku.value, sku, goodId: goodsInfo.value.goodId });
        EventBus.$emit('SkuChange', { sku, goodId: goodsInfo.value.goodId });
      } else {
        SkuVal.value = null;
      }
    };
    const addCartGoogle = (sku) => {
      const googleCartItem = {
        currency: root?.$cookies?.get('vsf-currency'),
        value: sku.price,
        items: [
          {
            item_id: goodsInfo.value.goodId,
            item_name: goodsInfo.value.title,
            price: sku.price,
            quantity: sku.num,
            item_variant: getSkuText(),
          },
        ],
      }

      root.$gtm.push(
        {
          event: "add_to_cart",
          ecommerce: googleCartItem
        });
    }
    const addToCart = async () => {
      const p = {};
      p.sku = getSkuBySelectedSku();
      p.skuText = skuText.value;
      p.num = selectedCount.value;
      if (isMobile.value) {
        notify.allDismiss();
      }
      if (p.sku && p.sku.skuId) {
        await addItem({ customQuery: { skuId: p.sku.skuId }, product: { goodId: goodsInfo.value.goodId }, quantity: selectedCount.value });
        if (!cartLoading.value) {
          toggleCartSidebar();
        }
        addCartGoogle(p.sku);
      } else {
        notify.send({
          type: 'danger',
          message: '没有选择规格'
        });
        // this.$toast.error("没有选择规格", {
        //   duration: 3000,
        //   position: "top-center",
        // });
      }
    };
    const addMsItemSku = () => {
      const p = {};
      p.sku = getSkuBySelectedSku();
      getSkuText(2);
      p.sku_prop = skuText.value;
      if (isMobile.value) {
        notify.allDismiss();
      }
      if (p.sku && p.sku.skuId) {
        emit('backSku', { ...p, goodId: goodsInfo.value.goodId, title: goodsInfo.value.title, imageUrl: goodsInfo.value.imageUrl });
      } else {
        notify.send({
          type: 'danger',
          message: '没有选择规格'
        });
        // this.$toast.error("没有选择规格", {
        //   duration: 3000,
        //   position: "top-center",
        // });
      }
    };
    const addToWishlist = () => {
      const p = {};
      p.skuText = skuText.value;
      p.sku = getSkuBySelectedSku();
      p.num = selectedCount.value;
      if (isMobile.value) {
        notify.allDismiss();
      }
      if (p.sku && p.sku.skuId) {
        const params = {};
        params.goodId = goodsInfo.value.goodId;
        params.skuId = p.sku.skuId;
        addItemToWishlist({ product: params });
      } else {
        notify.send({
          type: 'danger',
          message: '没有选择规格'
        });
      }
    };
    const initSeletdSku = () => {
      dataInfo.skuProps.forEach((item) => {
        if (dataInfo.skus.length === 1) {
          // seletedSku.value[item.propId] = item.values[0];
          // seletedSku.value[item.propId] = '';
          changeSelectedSku(item.propId, item.values[0]);
        } else {
          seletedSku.value[item.propId] = '';
          if (!seletedSku[item.propId]) {
            changeSelectedSku(item.propId, item.values[0]);
            // console.log('初始化sku', seletedSku[item.propId]);
          }
        }
      });
    };

    const initData = () => {
      initSeletdSku();
      initAllSku();
      getSkuText();
    };
    onMounted(() => {
      initData();
    });
    const loading = computed(() => {
      const sku = getSkuBySelectedSku();
      return !(sku && sku.skuId);
    });
    const changeNumber = (number) => {
      const sku = getSkuBySelectedSku();
      // console.log('number < sku?.stockNum', number < sku?.stockNum);
      if (seletedSku.value && number <= sku?.stockNum) {
        sku.exchangeRate = goodsInfo.value.exchangeRate;
        emit('changeSelectedSku', { result: seletedSku.value, sku, goodId: goodsInfo.value.goodId });
        EventBus.$emit('SkuChange', { sku, goodId: goodsInfo.value.goodId });
      } else {
        selectedCount.value = sku?.stockNum;
      }
    };
    return {
      goodsInfo,
      seletedSku,
      allSku,
      skuText,
      selectedCount,
      wishlist,
      initData,
      addToCart,
      isInWishlist,
      addToWishlist,
      addItemToWishlist,
      removeItemFromWishlist,
      changeSelectedSku,
      getSkuBySelectedSku,
      loading,
      addMsItemSku,
      isActive,
      isDisable,
      goItem,
      changeNumber,
      SkuVal,
      isMobile
    };
  }
};
</script>
<style lang="scss" >
.skuComponents{
  @include for-desktop {
    .skusList{
      overflow-y: auto;
      max-height: 26rem;
    }
  }
}
.sku-actions {
  .product__add-to-cart-box {
    display: block;

    .sf-add-to-cart__select-quantity {
      margin-bottom: 1rem;
      width: 100%;

      .sf-quantity-selector__input {
        flex: 1;
      }

      .sf-quantity-selector__button {
        width: 6rem;
      }
    }

    .add_class_group {
      display: block;
      width: 100%;

      .product__add-to-cart {
        margin: 0 0 1rem 0;
        display: block;
        width: 100%;
      }

      .product__add-to-wishlist {
        margin: 0 0 1rem 0;
        display: block;
        width: 100%;
      }
    }
  }
}
.goodPostage {
  @include for-mobile {
    margin: 0 var(--spacer-lg);
    margin-left: 0;
    margin-bottom: var(--spacer-lg);
    margin-right: 0;
  }
  margin-bottom: var(--spacer-sm);
}
</style>
